import register from '../../../../global/js/registry';
export default register('m-fhw-profile-header', () => import(/* webpackMode: "lazy" */ './m-fhw-profile-header.controller'));
